import ProgressBlockContainer from './progress-block.container';
export default ProgressBlockContainer;
